module.exports = __webpack_public_path__ + "img/roleManagement.6bd98097.svg";